import { buildHeartbeats } from './snapshot';
const WINDOW_MS = 60000;
const emptySource = ()=>({
        connections: 0,
        workerClients: 0,
        channels: 0,
        projectsSubscribed: 0,
        messageTimestamps: [],
        messagesReceived1m: null
    });
const state = {
    accountId: null,
    workerUrlKind: 'n_a',
    main: emptySource(),
    worker: emptySource()
};
export const MESSAGE_WINDOW_MS = WINDOW_MS;
export const pruneMessageTimestamps = (timestamps, now)=>{
    const cutoff = now - WINDOW_MS;
    return timestamps.filter((timestamp)=>timestamp >= cutoff);
};
export const setHeartbeatAccountId = (accountId)=>{
    state.accountId = accountId;
};
export const setWorkerUrlKind = (workerUrlKind)=>{
    state.workerUrlKind = workerUrlKind;
};
export const recordMainThreadConnection = (connected)=>{
    state.main.connections = connected ? 1 : 0;
};
export const recordMainThreadChannels = (channels)=>{
    state.main.channels = channels;
};
export const recordMainThreadMessage = (now = Date.now())=>{
    state.main.messageTimestamps.push(now);
    state.main.messageTimestamps = pruneMessageTimestamps(state.main.messageTimestamps, now);
};
export const recordSharedWorkerStats = (payload)=>{
    state.worker.connections = payload.connections;
    state.worker.workerClients = payload.workerClients;
    state.worker.channels = payload.channels;
    state.worker.messagesReceived1m = payload.messagesReceived1m;
};
export const recordSharedWorkerProjects = (projectsSubscribed)=>{
    state.worker.projectsSubscribed = projectsSubscribed;
};
export const getHeartbeatInput = (now = Date.now())=>{
    var _state_worker_messagesReceived1m;
    state.main.messageTimestamps = pruneMessageTimestamps(state.main.messageTimestamps, now);
    state.worker.messageTimestamps = pruneMessageTimestamps(state.worker.messageTimestamps, now);
    return {
        accountId: state.accountId,
        workerUrlKind: state.workerUrlKind,
        main: {
            connections: state.main.connections,
            workerClients: 0,
            channels: state.main.channels,
            projectsSubscribed: 0,
            messagesReceived1m: state.main.messageTimestamps.length
        },
        worker: {
            connections: state.worker.connections,
            workerClients: state.worker.workerClients,
            channels: state.worker.channels,
            projectsSubscribed: state.worker.projectsSubscribed,
            messagesReceived1m: (_state_worker_messagesReceived1m = state.worker.messagesReceived1m) !== null && _state_worker_messagesReceived1m !== void 0 ? _state_worker_messagesReceived1m : state.worker.messageTimestamps.length
        }
    };
};
export const buildHeartbeatPayload = (now = Date.now())=>buildHeartbeats(getHeartbeatInput(now));
export const resetPusherHeartbeatStore = ()=>{
    state.accountId = null;
    state.workerUrlKind = 'n_a';
    state.main = emptySource();
    state.worker = emptySource();
};
